import { atom } from "jotai";

export interface AppBarSticky {
  appBarHeight: number;
  stickyHeight: number;
}

export const appBarStickyAtom = atom<AppBarSticky>({
  appBarHeight: 0,
  stickyHeight: 0,
});
